export default __webpack_public_path__ + "static/media/StateOfWomen.f9513596.png";